export default __webpack_public_path__ + "static/media/YT4Dhl_uHd8-HD.217c9968.jpg";